export * from './image-preview.service';


// WEBPACK FOOTER //
// ./src/app/content/shared/services/image-preview/index.ts